export var EmailTemplateType;
(function (EmailTemplateType) {
    EmailTemplateType[EmailTemplateType["Invitation"] = 1] = "Invitation";
    EmailTemplateType[EmailTemplateType["Ticket"] = 2] = "Ticket";
    EmailTemplateType[EmailTemplateType["WelcomeThankYou"] = 3] = "WelcomeThankYou";
    EmailTemplateType[EmailTemplateType["ReInvitationReminder"] = 4] = "ReInvitationReminder";
    EmailTemplateType[EmailTemplateType["RegisteredReminder"] = 5] = "RegisteredReminder";
    EmailTemplateType[EmailTemplateType["FinalDetails"] = 6] = "FinalDetails";
    EmailTemplateType[EmailTemplateType["PostEventThankYou"] = 7] = "PostEventThankYou";
})(EmailTemplateType || (EmailTemplateType = {}));
